import styled from 'styled-components/native';
import { HeightProps, MarginProps, WidthProps, margin, flex, FlexProps } from 'styled-system';

import { Colors } from 'theme/colors';
import { BORDER_RADIUS } from 'theme/sizes';
import { height, width } from 'theme/responsive';

export const CheckBoxBase = styled.View<CheckBoxBaseProps & HeightProps & WidthProps>`
  align-items: center;
  border-width: 1px;
  background-color: ${({ checkedColor, isChecked }) => {
    const color = checkedColor ?? Colors.emerald;

    if (isChecked) {
      return color;
    }

    return Colors.white;
  }};
  border-color: ${({ checkedColor, isChecked }) => {
    const color = checkedColor ?? Colors.emerald;

    if (isChecked) {
      return color;
    }

    return Colors.steel;
  }};
  border-style: solid;
  border-radius: ${BORDER_RADIUS}px;
  align-items: center;
  justify-content: center;
  ${height}
  ${width}
`;

export const CheckBoxLabel = styled.View<MarginProps>`
  flex: 1;
  margin-top: auto;
  margin-bottom: auto;
  ${margin};
`;

export const CheckBoxWrapper = styled.View<MarginProps & FlexProps>`
  margin-top: 10px;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: flex-start;
  ${margin};
  ${flex};
`;

export const CheckBoxContainer = styled.View`
  align-self: center;
`;
/** CheckBoxBase props */
interface CheckBoxBaseProps {
  /** Describes whether the checkbox is checked or not */
  isChecked?: boolean;
  /** Color to make the checkbox when it is ticked */
  checkedColor?: string;
}
